module.exports = __webpack_public_path__ + "img/hills-tramcar-tour.b7c4cc94.jpg";